import * as S from "./FindAccountTemplate.style";
import { Header } from "@/components/organisms/Header";
import { Buttons } from "@/components/atoms/Buttons";
import { useLocation, useNavigate } from "react-router";
import { ReactComponent as IconArrow } from "@/styles/assets/svg/icon_arrow.svg";

interface FindAccountTemplateProps {
  children: React.ReactElement;
}

export const FindAccountTemplate = ({ children }: FindAccountTemplateProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <S.FindAccountTemplate>
      <Header
        headerTitle={
          location.pathname.includes("id")
            ? "아이디 찾기"
            : location.pathname.includes("password")
            ? "비밀번호 찾기"
            : "계정 찾기"
        }
        buttonLeft={
          <Buttons
            type="button"
            size="headerTextIcon"
            layout="text"
            color="bright100"
            icon={<IconArrow />}
            label="메인"
            onClick={() => navigate("/auth/login")}
          />
        }
      />
      <S.FindAccountContent>{children}</S.FindAccountContent>
    </S.FindAccountTemplate>
  );
};
